import { validateEmail } from "../../utils/validations";

export const validate = (email: string, password: string) => {
  if (!email || !password) return "Por favor rellene todos los campos";
  if (!validateEmail(email)) return "Por favor escriba un email válido";
};
